export default "<!-- edit privay-policy -->\r\n"